export default __webpack_public_path__ + "static/media/client-16.05d9ad29.png";